import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ProductBagIconButton from "./Header/ProductBagIconButton";

const MiniCart = () => {
    const { quantity, orderTotal, checkoutUrl, showInfo } = useSelector(
        (state) => state.cart
    );
    const translations = useSelector(state => state.navigation.translations);
    const myQuotes = translations?.myQuotes ?? 'Quote';
    return (
        <ProductBagIconButton quantity={quantity} text={myQuotes} icon="quote" href={checkoutUrl} active={quantity > 0}/>
    );
};

export default MiniCart;
